import { useDispatch, useSelector } from 'react-redux';
import {
  idToken as idTokenSelector,
  personSelector
} from '~/App/shared/selectors/sessionSelector';
import { useCallback, useState } from 'react';
import { FormData } from '../components/BiddingViewAuth/OrganisationMemberDetailsForm';
import { useTranslation } from '~/Locale';
import { sessionUpdate } from '~/App/shared/actions/session';
import { updateMemberSimple } from '~/helpers/orchestration/member';

export const useMemberDataUpdate = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const idToken = useSelector(idTokenSelector);
  const { organisation } = useSelector(personSelector) ?? {};
  const [isSavingAccountDetails, setIsSavingAccountDetails] = useState(false);
  const [isSavingAccountDetailsError, setIsSavingAccountDetailsError] =
    useState(false);
  const {
    organisationNumber: storedOrganisationNumber,
    vatNumber: storedVatNumber
  } = organisation ?? {};

  const saveAccountDetailsCallback = useCallback(
    async (memberDetailsFormData: FormData) => {
      isSavingAccountDetailsError && setIsSavingAccountDetailsError(false);
      setIsSavingAccountDetails(true);

      const {
        address,
        zipCode,
        city,
        country,
        organisationNumber,
        vatNumber,
        automaticAddressEnabled
      } = memberDetailsFormData;

      try {
        const { data } = await updateMemberSimple({
          data: {
            addresses: [
              { address1: address, zipCode, city, country: country?.value }
            ],
            organisation:
              !storedOrganisationNumber || !storedVatNumber
                ? {
                    organisationNumber: !storedOrganisationNumber
                      ? organisationNumber
                      : undefined,
                    vatNumber:
                      !storedVatNumber && country?.value !== 'se'
                        ? vatNumber
                        : undefined
                  }
                : undefined,
            automaticAddressEnabled
          },
          idToken
        });

        dispatch(
          sessionUpdate({
            auth: data.auth,
            member: data.member,
            t
          })
        );
      } catch (err: unknown) {
        console.log(err);
        setIsSavingAccountDetailsError(true);
      } finally {
        setIsSavingAccountDetails(false);
      }
    },
    [
      dispatch,
      idToken,
      isSavingAccountDetailsError,
      storedOrganisationNumber,
      storedVatNumber,
      t
    ]
  );

  return {
    saveAccountDetailsCallback,
    isSavingAccountDetails,
    isSavingAccountDetailsError
  };
};
